export default "__VITE_ASSET__QoEoNAeV__"